import React from 'react';
import { Button, DatePicker, Spin, Table } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useAnnouncementQuery } from './hooks/useAnnouncementQuery';
import dayjs from 'dayjs';
import type { ColumnsType } from 'antd/es/table';
import { FT121 } from '../../services/t102Api';

const columns: ColumnsType<FT121> = [
  {
    title: '公告代號',
    dataIndex: 'ft121_01',
    key: 'ft121_01',
    width: 120,
    sorter: (a, b) => a.ft121_01.localeCompare(b.ft121_01),
  },
  {
    title: '開始日期',
    dataIndex: 'ft121_11',
    key: 'ft121_11',
    width: 120,
    render: (v: string | null) => v ? dayjs(v).format('YYYY-MM-DD') : '-',
    sorter: (a, b) => (a.ft121_11 || '').localeCompare(b.ft121_11 || ''),
  },
  {
    title: '截止日期',
    dataIndex: 'ft121_12',
    key: 'ft121_12',
    width: 120,
    render: (v: string | null) => v ? dayjs(v).format('YYYY-MM-DD') : '-',
    sorter: (a, b) => (a.ft121_12 || '').localeCompare(b.ft121_12 || ''),
  },
  {
    title: '公告主題',
    dataIndex: 'ft121_21',
    key: 'ft121_21',
    width: 200,
    ellipsis: true,
  },
  {
    title: '公告內容',
    dataIndex: 'ft121_22',
    key: 'ft121_22',
    ellipsis: true,
  },
];

const T402Form: React.FC = () => {
  const {
    loading, records, total,
    startDate, endDate, setStartDate, setEndDate,
    handleQuery,
  } = useAnnouncementQuery();

  return (
    <Spin spinning={loading}>
      <div className="max-w-5xl mx-auto p-6">
        <h2 className="text-xl font-bold mb-4">
          公告查詢 (pwt402f1)
          <span className="ml-3 text-sm font-normal text-gray-500">
            共 {total} 筆
          </span>
        </h2>

        {/* Query controls */}
        <div className="flex items-center gap-3 mb-4 flex-wrap">
          <span className="text-sm text-gray-600">查詢起始日：</span>
          <DatePicker
            value={startDate}
            onChange={(d) => d && setStartDate(d)}
            allowClear={false}
            style={{ width: 150 }}
          />
          <span className="text-sm text-gray-600">查詢截止日：</span>
          <DatePicker
            value={endDate}
            onChange={(d) => d && setEndDate(d)}
            allowClear={false}
            style={{ width: 150 }}
          />
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleQuery}
          >
            開始查詢
          </Button>
        </div>

        {/* Results table */}
        <Table<FT121>
          columns={columns}
          dataSource={records}
          rowKey="ft121_01"
          pagination={{ pageSize: 50, showSizeChanger: true, showTotal: (t) => `共 ${t} 筆` }}
          size="small"
          scroll={{ x: 800 }}
          expandable={{
            expandedRowRender: (record) => (
              <div style={{ whiteSpace: 'pre-wrap', padding: '8px 0' }}>
                {record.ft121_22 || '(無內容)'}
              </div>
            ),
            rowExpandable: (record) => !!record.ft121_22,
          }}
        />
      </div>
    </Spin>
  );
};

export default T402Form;
